import {
  ApplicationSectionRatePlanFormDto,
  type ApplicationSectionRatePlanFormInterface,
} from '@zaoblako/shared/modules/security/dtos/application/section/application-section-rate-plan-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';
import { mapSchema } from '@zaoblako/shared/modules/serde/schemas/map.schema';

import * as yup from 'yup';

/** Application module request body for rate plan create/update APIs - DTO signature */
export interface ApplicationModuleRatePlanFormInterface {
  /** Is module enabled for tenant */
  enabled: boolean;
  /** Module sections */
  sections: Record<string, ApplicationSectionRatePlanFormInterface>;
}

/** Application module request body for rate plan create/update APIs - DTO schema */
export const ApplicationModuleRatePlanFormDto = SerdeDtoClass.create<ApplicationModuleRatePlanFormInterface>(
  SecurityDtoKeysEnum.APPLICATION_MODULE_RATE_PLAN_FORM_DTO,
  {
    enabled: {
      label: 'Модуль включен',
      serializer: yup.boolean(),
    },
    sections: {
      label: 'Разделы',
      nested: ApplicationSectionRatePlanFormDto,
      serializer: (_, nested) => mapSchema(
        yup.string(),
        nested,
      ),
    },
  },
);
